import { VueModule } from '@Foundation';
import Panel from './code/Scripts/components/panel';

export default VueModule({
  components: {
    Panel
  }
});
